import React, { useState } from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import './contact.css'

export const Contact = () => {
  const [visible, setvisible] = useState(false);

  const sumbitForm = () => {
    var name = document.getElementById("name").value;
    var subject = document.getElementById("subject").value;

    window.open(
      "mailto:ayronvanhee@gmail.com?subject=Porfolio Contact " +
        encodeURI(name) +
        "&body=" +
        encodeURI(subject)
    );
    setvisible(true);
  };

  const showForm = () => {
    return (
      <div>
        <h1 className="SecondaryTitle">Contact</h1>
        <div className="ContactForm">
          <div>
            <form onSubmit={sumbitForm} method="post" encType="text/plain">
              <label className="ContactForm_Label" htmlFor="name">
                Naam
              </label>
              <input
                id="name"
                name="name"
                type="text"
                placeholder="Naam"
                className="ContactForm_Input"
                minLength="3"
                required
              />

              <label className="ContactForm_Label" htmlFor="subject">
                Onderwerp
              </label>
              <textarea
                id="subject"
                type="text"
                name="subject"
                placeholder="We contacteren je omdat..."
                className="ContactForm_Input"
                rows="5"
                minLength="10"
                required
                maxLength="650"
              ></textarea>

              <input
                className="ContactForm_Button"
                type="submit"
                value="Verstuur"
                required
              />
            </form>
          </div>

          <div className="ContactBox">
            <h3>Contact Informatie</h3>
            <div className="ContactBox_Grid">
            <div className="ContactBox_Div">
              <FontAwesomeIcon className="ContactBox_Div_Image" icon={faEnvelope} />
              <span>ayronvanhee@gmail.com</span>
            </div>
            <div className="ContactBox_Div">
              <FontAwesomeIcon className="ContactBox_Div_Image" icon={faPhone} />
              <span>0470 23 43 12</span>
            </div>

            <a
              className="ContactBox_Div"
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.linkedin.com/in/ayron-vanhee-145149195/"
            >
              <FontAwesomeIcon className="ContactBox_Div_Image" icon={faLinkedin} />
            </a>
          </div>
          </div>
        </div>
      </div>
    );
  };

  const showThanks = () => {
    return (
      <div>
        <div className="ThanksTitle">Bedankt!</div>
        <div className="ThanksSubTitle">
          Ik zal zo snel mogelijk contact met u opnemen.
        </div>
      </div>
    );
  };

  return (
    <div>
      <div>
        {!visible && showForm()}
        {visible && showThanks()}
      </div>
    </div>
  );
};
